import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';

const Home = lazy(() => import('./pages/Home'));
const Root = lazy(() => import('./Root'));

function BoundoryError() {
  return null;
}

function LoaderFallback() {
  return (
    <div
      style={{
        minHeight: '100svh',
        display: 'flex',
        marginTop: '200px',
        justifyContent: 'center'
      }}>
      <p
        style={{
          fontSize: '1rem',
          fontWeight: 'bold'
        }}>
        ...chargement
      </p>
    </div>
  );
}
const routes = createBrowserRouter([
  {
    path: '/apple-pay/ar',
    element: <Root />,
    errorElement: <BoundoryError />,

    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoaderFallback />}>
            <Home />
          </Suspense>
        )
      }
    ]
  },
  {
    path: '/apple-pay/fr',
    element: <Root />,
    errorElement: <BoundoryError />,

    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoaderFallback />}>
            <Home />
          </Suspense>
        )
      }
    ]
  },

  {
    path: '/apple-pay',
    element: <Root />,
    errorElement: <BoundoryError />,

    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoaderFallback />}>
            <Home />
          </Suspense>
        )
      }
    ]
  }
]);

export default routes;
